import React from 'react'
import compose from 'recompose/compose'
import {withI18n} from '../../hocs'
import PropTypes from 'prop-types'
import MaterialTable from 'material-table'
import TableStatisticStyled from './styled'
import i18n from '../../../assets/i18n'
import {MTCircularPercent, MTText} from '../../atoms'

const MTPercent = value => <MTCircularPercent value={value} />

const TableStatistic = ({ title, i18n, data }) => {
  const tableOptions = {
    emptyRowsWhenPaging: false,
    paginationType: 'stepped',
    loadingType: 'linear',
    pageSize: 20,
    pageSizeOptions: [20, 50, 100, 200],
  }

  const tableComponents = {
    Container: MTContainer,
    Toolbar: () => ''
  }

  const columns = [
    {
      title: i18n.processesStatisticsItems.processes,
      field: 'process_name',
      render: rowData => TextItem(rowData.process_name),
      cellStyle: { textAlign: 'left' }
    },
    {
      title: i18n.processesStatisticsItems.total,
      field: 'processes',
      render: rowData => TextItem(rowData.processes),
      cellStyle: { textAlign: 'left' }
    },
    {
      title: i18n.processesStatisticsItems.recived,
      field: 'procceses_received_percent',
      render: rowData => MTPercent(Math.round(rowData.procceses_received_percent)),
      cellStyle: { textAlign: 'left' }
    },
    {
      title: i18n.processesStatisticsItems.suitablesVsRecibidos,
      field: 'procceses_in_process_percent',
      render: rowData => MTPercent(Math.round(rowData.procceses_in_process_percent)),
      cellStyle: { textAlign: 'left' }
    },
    {
      title: i18n.processesStatisticsItems.suitables,
      field: 'procceses_processed_percent	',
      render: rowData => MTPercent(Math.round(rowData.procceses_processed_percent	)),
      cellStyle: { textAlign: 'left' }
    }
  ]

  return (
    <TableStatisticStyled>
      <div className="header-stat">
        <p>{title}</p>
      </div>
      <div className="table-wrapper">
        <MaterialTable
          search={false}
          columns={columns}
          data={data ? data : []}
          options={tableOptions}
          components={tableComponents}
          localization={i18n.tableLocalization}
          draggable={false}
        />
      </div>
    </TableStatisticStyled>
  )
}

const MTContainer = props => <div {...props} />

const TextItem = value => <MTText value={value} />

TableStatistic.propTypes = {
  title: PropTypes.string,
  i18n: PropTypes.object.isRequired,
  data: PropTypes.array,
  isFetching: PropTypes.bool
}

TableStatistic.defaultProps = {
  title: i18n.processesStatisticsItems.tableTitle,
  data: [],
  isFetching: false
}

const enharce = compose(withI18n)

export default enharce(TableStatistic)
